import Simple from "./simple";

/**
 * @class
 */
export default class BundleItem extends Simple {}
